import axios from "../axios-auth";
import orginal_axios from "axios";

export const glListingService = {
    getGLlisting,
    getGLlistingPrint,
    getGlListingDetailList,
    getGLreferenceDetailList,
    getGlListingExcelExport
};

function getGLlisting(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    } if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromMonth) {
        params["fromMonth"] = searchParams.fromMonth;
    }
    if (searchParams.toMonth) {
        params["toMonth"] = searchParams.toMonth;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.accountCode) {
        params["accountCode"] = searchParams.accountCode;
    }
    if (searchParams.accountName) {
        params["accountName"] = searchParams.accountName;
    }
    if (searchParams.accountHeadId) {
        params["accountHeadId"] = searchParams.accountHeadId;
    }

    return axios.get("/auth/gl-lists", { params });
}

function getGLlistingPrint(searchParams) {
    let params = {};

    if (searchParams.fromMonth) {
        params["fromMonth"] = searchParams.fromMonth;
    }
    if (searchParams.toMonth) {
        params["toMonth"] = searchParams.toMonth;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.accountCode) {
        params["accountCode"] = searchParams.accountCode;
    }
    if (searchParams.accountName) {
        params["accountName"] = searchParams.accountName;
    }
    if (searchParams.accountHeadId) {
        params["accountHeadId"] = searchParams.accountHeadId;
    }

    return axios.get("/auth/gl-lists", { params });
}

function getGlListingDetailList(searchParams, sortedBy) {
    let params = {
        sort: sortedBy
    };

    if (searchParams.fromMonth) {
        params["fromMonth"] = searchParams.fromMonth;
    }
    if (searchParams.toMonth) {
        params["toMonth"] = searchParams.toMonth;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.coaId) {
        params["coaId"] = searchParams.coaId;
    }
    if (searchParams.nature) {
        params["nature"] = searchParams.nature;
    }
    if (typeof searchParams.openingBalance == 'number') {
        params["openingBalance"] = searchParams.openingBalance;
    }
    if (typeof searchParams.closingBalance == 'number') {
        params["closingBalance"] = searchParams.closingBalance;
    }

    return axios.get("/auth/gl-list-details", { params });
}

function getGLreferenceDetailList(generalLedgerId, accountId, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    } if (!size) {
        size = 50;
    }
    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (generalLedgerId) {
        params["generalLedgerId"] = generalLedgerId;
    }

    if (accountId) {
        params["accountId"] = accountId;
    }

    return axios.get("/auth/gl-reference-detail-lists", { params });
}

function getGlListingExcelExport(searchParams) {
    let params = {
    };
    if (searchParams.fromMonth) {
        params["fromMonth"] = searchParams.fromMonth;
    }
    if (searchParams.toMonth) {
        params["toMonth"] = searchParams.toMonth;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.accountCode) {
        params["accountCode"] = searchParams.accountCode;
    }
    if (searchParams.accountName) {
        params["accountName"] = searchParams.accountName;
    }
    if (searchParams.accountHeadId) {
        params["accountHeadId"] = searchParams.accountHeadId;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/gl-lists-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}